/**
 * Overlay di conferma (fixed inset + card).
 * Usa <button> nativi: GreenButton/GreyButton avvolgono <Link> e non sono adatti qui.
 */
const ConfirmDialog = ({
    isOpen,
    title,
    message,
    confirmLabel,
    cancelLabel,
    confirmingLabel,
    onConfirm,
    onCancel,
    isConfirming,
    confirmButtonClass = 'primary',
    error,
}) => {
    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 bg-black/70 z-50 flex flex-col items-center justify-center p-4"
            role="dialog"
            aria-modal="true"
            aria-labelledby="confirm-dialog-title"
        >
            <div className="bg-white p-6 max-w-md w-full rounded-xl flex flex-col gap-4 shadow-lg">
                <h2 id="confirm-dialog-title" className="text-lg font-semibold text-[#225424]">
                    {title}
                </h2>
                {message && <p className="text-neutral-700 text-sm">{message}</p>}
                {error && <p className="text-red-600 text-sm">{error}</p>}
                <div className="flex flex-col-reverse sm:flex-row gap-3 sm:justify-end pt-2">
                    <button
                        type="button"
                        className="secondary w-full sm:w-auto"
                        onClick={onCancel}
                        disabled={isConfirming}
                    >
                        {cancelLabel}
                    </button>
                    <button
                        type="button"
                        className={`${confirmButtonClass} w-full sm:w-auto disabled:opacity-50 disabled:cursor-not-allowed`}
                        onClick={onConfirm}
                        disabled={isConfirming}
                    >
                        {isConfirming ? (confirmingLabel || '…') : confirmLabel}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmDialog;
